import { type ReactElement } from 'react';
import { type CustomTooltipProps } from './types';

const DEFAULT_FORMAT_LABEL = (label: string | number | undefined): string => {
  if (!label) return '';
  return typeof label === 'string' ? label.split(' (')[0] : String(label);
};

const COLON_SEPARATOR = ': ';

export const CustomTooltip = <T extends Record<string, unknown>>({
  active,
  payload,
  label,
  categories,
  getCategoryLabel,
  formatLabel = DEFAULT_FORMAT_LABEL,
}: CustomTooltipProps<T>): ReactElement | null => {
  if (!active || !payload?.length) return null;

  const data = payload[0].payload;

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
      <p className="text-sm font-semibold text-gray-800 mb-2">{DEFAULT_FORMAT_LABEL(label)}</p>
      <div className="flex flex-col gap-1">
        {categories.map(category => {
          const value = data[category];
          if (value === undefined || typeof value !== 'number') return null;

          const payloadItem = payload.find(p => p.dataKey === category);
          const color = payloadItem?.color || '#000';
          const label = getCategoryLabel ? getCategoryLabel(category) : category;

          return (
            <div key={category} className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: color }} />
              <span className="text-xs text-gray-600">
                {label}
                {COLON_SEPARATOR}
                {formatLabel ? formatLabel(value) : value}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
